import styled from "styled-components/macro"

export default styled.svg`
    width: ${props => props.width ? props.width : '50px'};
    height: ${props => props.height ? props.height : '50px'};
    transform: rotate(-90deg);
`